import { render, staticRenderFns } from "./AddVTPage.vue?vue&type=template&id=fc82d224&"
import script from "./AddVTPage.vue?vue&type=script&lang=js&"
export * from "./AddVTPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports